export default function ChatLandingPage() {
  return (
    <div className="w-[80%] relative bg-white rounded-xl shadow border border-indigo-400 border-opacity-30 hidden xl:block">
      <div className="w-full h-full flex justify-center items-center">
        <img src='https://res.cloudinary.com/drlcisipo/image/upload/v1705704285/Website%20images/Emails-cuate_1_bi6b7h.png' />
      </div>
    </div>
  );
}
